type AppSSHCommands = {
  appName?: string;
  withoutWorkers?: { instance: string; sshCommand: string }[];
  withWorkers?: {
    instances: { instance: string; sshCommand: string }[];
    workerName: string;
  }[];
};

type AppCLICommands = {
  appName?: string;
  withoutWorkers?: { instance: string; cliCommand: string }[];
  withWorkers?: {
    instances: { instance: string; cliCommand: string }[];
    workerName: string;
  }[];
};

export const sortSSHCommands = (sshUrls: Record<string, string>) => {
  const commands: AppSSHCommands[] = [];
  Object.keys(sshUrls).forEach(key => {
    const app = key.split("--")[0].split(":")[0];
    const appInstance = key.split("--")[0].split(":")[1];
    const worker = key.split("--")[1]?.split(":")[0];
    const workerInstance = key.split("--")[1]?.split(":")[1];
    const isAppAdded = commands.find(command => command?.appName === app);

    if (!isAppAdded) {
      commands.push({ appName: app, withWorkers: [], withoutWorkers: [] });
    }
    const appCommands = commands.find(command => command?.appName === app);
    !worker &&
      appCommands?.withoutWorkers?.push({
        instance: appInstance || workerInstance,
        sshCommand: sshUrls[key].replace("ssh://", "ssh ")
      });

    const isWorkerAdded =
      worker &&
      appCommands?.withWorkers?.find(
        withWorker => withWorker.workerName === worker
      );
    if (isWorkerAdded) {
      isWorkerAdded.instances.push({
        instance: workerInstance,
        sshCommand: sshUrls[key].replace("ssh://", "ssh ")
      });
    } else {
      worker &&
        appCommands?.withWorkers?.push({
          workerName: worker,
          instances: [
            {
              instance: workerInstance,
              sshCommand: sshUrls[key].replace("ssh://", "ssh ")
            }
          ]
        });
    }
  });
  return commands.map(cmd => {
    cmd.withoutWorkers &&
      cmd.withoutWorkers?.length > 1 &&
      !cmd.withoutWorkers?.[0].instance &&
      cmd.withoutWorkers?.shift();

    cmd.withWorkers?.map(
      wrkr =>
        wrkr.instances.length > 1 &&
        !wrkr.instances?.[0].instance &&
        wrkr.instances?.shift()
    );

    return {
      appName: cmd.appName,
      withoutWorkers: cmd.withoutWorkers,
      withWorkers: cmd.withWorkers
    };
  });
};

export const sortCLICommands = ({
  sshUrls,
  projectId,
  environmentName,
  intl
}) => {
  const commands: AppCLICommands[] = [];
  Object.keys(sshUrls).forEach(key => {
    //--project $projectID --environment $environmentName
    //project; environment; instance; app; worker;

    // First, check for old DG-2 config where instances were marked with `ent-`
    let app = "";
    let appInstance = "";
    if (key.indexOf("ent-") === 0) {
      appInstance = key.substring(4);
    } else {
      app = key.split("--")[0].split(":")[0];
      appInstance = key.split("--")[0].split(":")[1];
    }
    const worker = key.split("--")[1]?.split(":")[0];
    const workerInstance = key.split("--")[1]?.split(":")[1];
    const isAppAdded = commands.find(command => command?.appName === app);

    if (!isAppAdded) {
      commands.push({ appName: app, withWorkers: [], withoutWorkers: [] });
    }
    const appCommands = commands.find(command => command?.appName === app);
    const appString = app ? `--app ${app}` : "";
    const instance =
      appInstance || workerInstance
        ? `--instance ${appInstance || workerInstance}`
        : ``;
    !worker &&
      appCommands?.withoutWorkers?.push({
        instance: appInstance || workerInstance,
        cliCommand: `${intl.formatMessage({
          id: "CLI_command_name"
        })} ssh --project ${projectId} --environment ${environmentName}  ${instance} ${appString}`
      });

    const isWorkerAdded =
      worker &&
      appCommands?.withWorkers?.find(
        withWorker => withWorker.workerName === worker
      );
    if (isWorkerAdded) {
      const instance = workerInstance ? `--instance ${workerInstance}` : "";
      isWorkerAdded.instances.push({
        instance: workerInstance,
        cliCommand: `${intl.formatMessage({
          id: "CLI_command_name"
        })} ssh --project ${projectId} --environment ${environmentName} ${instance} ${appString} --worker ${worker}`
      });
    } else {
      const instance = workerInstance ? `--instance ${workerInstance}` : "";

      worker &&
        appCommands?.withWorkers?.push({
          workerName: worker,
          instances: [
            {
              instance: workerInstance,
              cliCommand: `${intl.formatMessage({
                id: "CLI_command_name"
              })} ssh --project ${projectId} --environment ${environmentName} ${instance} ${appString} --worker ${worker}`
            }
          ]
        });
    }
  });
  return commands.map(cmd => {
    cmd.withoutWorkers &&
      cmd.withoutWorkers?.length > 1 &&
      !cmd.withoutWorkers?.[0].instance &&
      cmd.withoutWorkers?.shift();

    cmd.withWorkers?.map(
      wrkr =>
        wrkr.instances.length > 1 &&
        !wrkr.instances?.[0].instance &&
        wrkr.instances?.shift()
    );

    return {
      appName: cmd.appName,
      withoutWorkers: cmd.withoutWorkers,
      withWorkers: cmd.withWorkers
    };
  });
};
